<template>
  <sh-modal
    label="RSM Assistant Feedback"
    id="feedback-modal"
    modal-height="550px"
    modal-width="650px"
    @modal-closed="closeFeedbackModal"
    ><div
      style="
        text-align: left;
        margin-top: 50px;
        margin-left: 50px;
        margin-right: 50px;
        margin-bottom: 50px;
      "
    >
      <div style="display: flex">
        <sh-text>Please rate your experience with the app: </sh-text>
        <div style="width: 100px">
          <star-rating
            v-model:rating="appRating"
            :show-rating="false"
            :star-size="20"
            @rating-selected="setAppRating($event)"
          ></star-rating>
        </div>
      </div>
      <div style="margin-top: 16px">
        <sh-input-text
          textarea
          rows="5"
          :value="appRatingInput"
          @value-changed="setAppRatingInput($event)"
          label="Tell us more about your experience:"
        ></sh-input-text>
      </div>
      <div style="margin-top: 16px">
        <sh-input-text
          textarea
          rows="5"
          :value="appRatingSuggestion"
          @value-changed="setAppRatingSuggestion($event)"
          label="What more would you like to see?"
        ></sh-input-text>
      </div>
      <div style="margin-top: 16px">
        <sh-button
          size="m"
          label="Submit"
          :disabled="!appRating"
          @click="submitUserFeedback"
        >
        </sh-button>
      </div>
    </div>
  </sh-modal>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FeedbackModal",
  components: { StarRating },
  props: [],
  data() {
    return {
      appRating: null,
      appRatingInput: "",
      appRatingSuggestion: "",
    };
  },
  mounted() {},
  created() {},
  beforeUnmount() {
    console.log("Feedback component destroyed!");
  },
  computed: {
    ...mapGetters(["backendURL"]),
    ...mapGetters("oidcStore", ["oidcUser"]),
  },
  methods: {
    ...mapActions(["pushNotification"]),
    getCurrentDate() {
      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        ("0" + m.getUTCDate()).slice(-2) +
        " " +
        ("0" + m.getUTCHours()).slice(-2) +
        ":" +
        ("0" + m.getUTCMinutes()).slice(-2) +
        ":" +
        ("0" + m.getUTCSeconds()).slice(-2);
      return dateString;
    },

    closeFeedbackModal() {
      document.querySelector("#feedback-modal").visible = false;
      this.appRating = null;
      this.appRatingInput = "";
      this.appRatingSuggestion = "";
    },

    setAppRating($event) {
      this.appRating = $event;
    },

    setAppRatingInput($event) {
      this.appRatingInput = $event.target.value;
    },

    setAppRatingSuggestion($event) {
      this.appRatingSuggestion = $event.target.value;
    },

    submitUserFeedback() {
      let payload = {
        username: this.oidcUser ? this.oidcUser.email : "",
        time: this.getCurrentDate(),
        rating: this.appRating,
        comment: this.appRatingInput,
        suggestion: this.appRatingSuggestion,
        category: "feedback",
      };
      console.log(payload);

      axios
        .post(this.backendURL + "/api/application_feedback", payload)
        .then((res) => {
          console.log("feedback submitted ", res.data);
          let notification = {
            type: "success",
            label: "Feedback received",
            duration: "short",
            text: "Feedback submitted!",
          };
          this.pushNotification(notification);
        })
        .catch((err) => {
          console.log(err);
          let notification = {
            type: "warning",
            label: "Feedback Error",
            duration: "short",
            text: "Feedback was not submitted!",
          };
          this.pushNotification(notification);
        });

      this.closeFeedbackModal();
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss"></style>
